export default "__VITE_ASSET__DVtkojZQ__"